import searchComponent from './searchComponent'
import './style.scss'

export default searchComponent


// WEBPACK FOOTER //
// ./src/components/searchComponent/index.js